export default __webpack_public_path__ + "static/media/element_30.3a92f339.jpg";